import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/Spectrum UXP Widgets/User Interface/sp-slider";
import * as React from 'react';
export default {
  Content,
  React
};